import { Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { UtilsService } from 'src/app/common';
import { DbcModel, DbcProductCarousel } from '../../model/dbc-model';

@Component({
  standalone: true,
  selector: 'gig-product-carousel',
  imports: [
    CommonModule,
    CarouselModule,
    ButtonModule,
  ],
  templateUrl: './product-carousel.component.html',
  styleUrls: ['./product-carousel.component.scss']
})
export class ProductCarouselComponent implements OnInit {

    @ViewChild('carouselTrack', { static: false }) carouselTrack!: ElementRef<HTMLDivElement>;
    @Input() productCarousel: DbcProductCarousel[] = [];
    @Input() dbCard: DbcModel | undefined;
    private utils = inject(UtilsService);

    ngOnInit(): void {
        this.utils.logger.info("[ProductCarouselComponent] Initialized Products");
    }

    onShowClick(url: string): void {
        window.open(url, '_blank');
    }

    nextSlide(): void {
        this.carouselTrack?.nativeElement.scrollBy({ left: this.carouselTrack.nativeElement.offsetWidth, behavior: 'smooth' });
    }

    prevSlide(): void {
        this.carouselTrack?.nativeElement.scrollBy({ left: -this.carouselTrack.nativeElement.offsetWidth, behavior: 'smooth' });
    }
}
